import React from "react";

export const Panel = ({ children, className = "", topEdge = false, hover = false, accent, ...rest }) => (
  <div
    className={`lv-panel ${topEdge ? "lv-top-edge" : ""} ${hover ? "lv-panel-hover" : ""} ${
      accent === "amber" ? "border-l-2 border-l-amber-500/70" : ""
    } ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const SectionHeading = ({ kicker, title, icon: Icon, right, className = "" }) => (
  <div className={`mb-3 flex items-end justify-between gap-4 ${className}`}>
    <div>
      {kicker && <div className="kicker mb-1">{kicker}</div>}
      <h2 className="flex items-center gap-2 text-lg font-semibold tracking-tight text-white sm:text-xl">
        {Icon && <Icon className="h-4 w-4 text-amber-400" strokeWidth={1.75} />}
        {title}
      </h2>
    </div>
    {right}
  </div>
);

export const PageTitle = ({ kicker, title, subtitle, right }) => (
  <div className="lv-fade-up mb-6 flex flex-col gap-3 border-b border-white/[0.07] pb-5 sm:flex-row sm:items-end sm:justify-between">
    <div>
      {kicker && <div className="kicker mb-1.5">{kicker}</div>}
      <h1 className="text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h1>
      {subtitle && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-zinc-400">{subtitle}</p>}
    </div>
    {right}
  </div>
);

export const SectionDivider = ({ className = "" }) => (
  <div className={`h-px w-full bg-gradient-to-r from-white/[0.09] via-white/[0.03] to-transparent ${className}`} />
);

export const MetricCard = ({ label, value, sub, icon: Icon, tone = "neutral", className = "", ...rest }) => {
  const toneClass =
    tone === "positive" ? "text-emerald-400" :
    tone === "negative" ? "text-rose-400" :
    tone === "amber" ? "text-amber-400" : "text-white";
  return (
    <div className={`lv-panel lv-panel-hover p-3.5 transition-transform duration-200 hover:-translate-y-0.5 ${className}`} {...rest}>
      <div className="flex items-center justify-between gap-2">
        <span className="kicker">{label}</span>
        {Icon && <Icon className="h-3.5 w-3.5 text-zinc-600" strokeWidth={1.75} />}
      </div>
      <div className={`mt-2 font-mono text-xl font-bold tabular-nums ${toneClass}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-zinc-500">{sub}</div>}
    </div>
  );
};

export const DataCard = ({ children, title, kicker, right, className = "", ...rest }) => (
  <Panel topEdge className={`p-4 sm:p-5 ${className}`} {...rest}>
    {(title || kicker) && (
      <div className="mb-3 flex items-center justify-between gap-3">
        <div>
          {kicker && <div className="kicker mb-0.5">{kicker}</div>}
          {title && <h3 className="text-sm font-semibold text-white">{title}</h3>}
        </div>
        {right}
      </div>
    )}
    {children}
  </Panel>
);
